export default __webpack_public_path__ + "static/media/diagram3_eng.544a9390.png";